(() => {
  if (customElements.get('lds-quick-view-ui')) return;
  const colors = {white:'#fff',red:'#e43b42',blue:'#263e9c','navy blue':'#263e9c',green:'#2a9d58',yellow:'#f0bc32','ice blue':'#43bde3',purple:'#8952bf',orange:'#ff852d',black:'#202124'};
  const badgeColors = {
    WHITE:'#fff',
    RED:'#ff2630',
    BLUE:'#2e46f5',
    GREEN:'#2ad263',
    YELLOW:'#ffd92a',
    'ICE BLUE':'#4cd8ff',
    PURPLE:'#b54fff',
  };
  const badgeFlowAliases = new Set(['FLOW', 'RGB', 'FLOW RGB', 'RGB FLOW', 'FLOW-RGB', 'RGB-FLOW']);
  const badgeColorKey = value => {
    const key = String(value ?? '').trim().replace(/[_/]+/g, ' ').replace(/\s*[-+]\s*/g, '-').replace(/\s+/g, ' ').toUpperCase();
    if (badgeFlowAliases.has(key)) return 'FLOW';
    if (key === 'ICEBLUE') return 'ICE BLUE';
    return badgeColors[key] ? key : null;
  };
  const badgeColorLabel = key => key === 'FLOW' ? 'Flow RGB' : key === 'ICE BLUE' ? 'Ice Blue' : key[0] + key.slice(1).toLowerCase();
  class QuickUI extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.root = this.closest('.hdt-main-section') || this.parentElement;
        this.isBadge = Boolean(this.root?.querySelector('lds-quick-preview[data-lds-preview-kind="badge"], lds-quick-preview[data-lds-badge-marker]'));
        this.root?.classList.toggle('lds-quick-view-badge', this.isBadge);
        this.root?.querySelector('.hdt-main-product-quick-view')?.classList.toggle('lds-quick-view-badge', this.isBadge);
        this.enhance();
        this.root.addEventListener('variant:change', () => this.enhance(), {signal:this.abort.signal});
        this.root.addEventListener('change', event => {
          if (this.isBadge && event.target.matches?.('hdt-variant-picker input[is-value]')) this.enhanceBadge();
        }, {signal:this.abort.signal});
      });
    }
    enhance() {
      if (!this.root) return;
      if (this.isBadge) {
        this.enhanceBadge();
        return;
      }
      for (const input of this.root.querySelectorAll('hdt-variant-picker input[is-value]')) {
        const label = this.root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!label) continue;
        const value = input.value.trim().toLowerCase();
        const swatch = label.querySelector('.hdt-form-color-pattern');
        if (swatch) {
          if (/flow|rgb/.test(value)) {swatch.style.background='linear-gradient(90deg,#f34,#fd3,#2c6,#4cf,#85f)'; label.title='Flow RGB';}
          else if (colors[value]) {swatch.style.background=colors[value]; label.title=input.value;}
        }
        if (/style|finish|surface/i.test(input.name) && /stainless|raptor/i.test(input.value)) {
          label.classList.add('lds-quick-material');
          if (!label.querySelector('.lds-quick-material-sample')) {
            const sample = document.createElement('span'); sample.className='lds-quick-material-sample';sample.setAttribute('aria-hidden','true');
            sample.dataset.material=/raptor/i.test(input.value)?'raptor':'steel';
            const title = document.createElement('span');title.className='lds-quick-material-title';title.textContent=/raptor/i.test(input.value)?'Black Raptor':'Stainless Steel';
            label.replaceChildren(sample,title);
          }
        }
      }
    }
    enhanceBadge() {
      const picker = this.root?.querySelector('hdt-variant-picker');
      if (!picker) return;
      const fields = [...picker.querySelectorAll('fieldset[data-index]')];
      const field = fields.find(candidate => {
        const legend = candidate.querySelector('legend')?.textContent || '';
        const name = candidate.querySelector('input[is-value]')?.name || '';
        return /(?:^|\s)(?:light\s+)?color(?:$|\s)/i.test(legend) || /(?:^|\s)(?:light\s+)?color(?:$|\s)/i.test(name);
      });
      if (!field) return;
      field.dataset.ldsBadgeColor = '';
      const selected = [...field.querySelectorAll('input[is-value]')].find(input => badgeColorKey(input.value) && (input.checked || input.getAttribute('aria-checked') === 'true'));
      const legendValue = field.querySelector('legend [update-value]');
      if (legendValue && selected) legendValue.textContent = badgeColorLabel(badgeColorKey(selected.value));
      for (const input of field.querySelectorAll('input[is-value]')) {
        const key = badgeColorKey(input.value);
        const label = input.id ? field.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        if (!key || !label) continue;
        label.classList.add('lds-badge-color-option');
        input.classList.add('lds-badge-color-input');
        let swatch = label.querySelector('.lds-badge-color-swatch');
        if (!swatch) {
          swatch = document.createElement('span');
          swatch.className = 'lds-badge-color-swatch';
          swatch.setAttribute('aria-hidden', 'true');
          label.prepend(swatch);
        }
        swatch.style.background = key === 'FLOW'
          ? 'linear-gradient(90deg,#ff2630 0%,#ffd92a 25%,#2ad263 50%,#4cd8ff 75%,#b54fff 100%)'
          : badgeColors[key];
        label.title = badgeColorLabel(key);
        label.setAttribute('aria-label', input.value);
        label.classList.toggle('is-selected', input.checked || input.getAttribute('aria-checked') === 'true');
      }
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  customElements.define('lds-quick-view-ui', QuickUI);
})();
